//
//
//
//
//
//
//
//
//
//
//

import HeaderComponent from "../headers/Header.vue";
import FooterComponent from "../footers/Footer.vue";
import SidebarComponent from "../sidebars/Sidebar.vue";

export default {
  name: "AuthLayout",
  components: {
    HeaderComponent,
    SidebarComponent,
    FooterComponent
  }
};
